import React from 'react';
import { SearchSuggestionButtonProps } from './search-suggestion.button.props';
import './search-suggestion.component.css';

const boldStartingTag = '<b0>';
const boldEndingTag = '</b0>';
const boldStartingTagLength = boldStartingTag.length;
const boldEndingTagLength = boldEndingTag.length;

/*
 * Implementing a button react component.
 */
export class SearchSuggestionButtonComponent extends React.Component<SearchSuggestionButtonProps> {

    public readonly handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.currentTarget.blur();
        this.props.handleClick(e);
    }

    public readonly handleKeyPress = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.currentTarget.blur();
            this.props.handleClick(e);
        }
    }

    public render() {
        const boldStartingIndex = this.props.title.indexOf(boldStartingTag);
        const boldEndingIndex = this.props.title.lastIndexOf(boldEndingTag);

        return (
            <div className={this.props.style !== undefined ? 'search-button-container ' + this.props.style : 'search-button-container'} onKeyDown={e => this.handleKeyPress(e)}>
                <a className='search-button-container__link' role='option' data-nav='true' tabIndex={-1} onClick={e => this.handleClick(e)} target={this.props.target}>
                    <div className='search-icon'>
                        <div className='search-icon__container'>
                            <div className={this.props.icon + ' search-icon--image'}></div>
                        </div>
                    </div>
                    <div className={this.props.isPwa && this.props.isDarkMode ? 'search-button-container__text--darkMode' : 'search-button-container__text'}>
                        { boldStartingIndex >= 0 ?
                        <div className='search-buttons-title'>
                            <span>{this.props.title.substring(0, boldStartingIndex)}</span>
                            <strong>{this.props.title.substring(boldStartingIndex + boldStartingTagLength, boldEndingIndex)}</strong>
                            <span>{this.props.title.substring(boldEndingIndex + boldEndingTagLength)}</span>
                        </div> :
                        <div>
                            <div className='search-buttons-title'>{this.props.title}</div>
                        </div>
                        }
                    </div>
                </a>
            </div>
        );
    }
}
